<div class="shrink configurator-dropdown" [attr.data-cy]="'dropdown-' + attribute.name">
  <udex-select-box
    mode="SingleSelect"
    (selection-change)="onSelectionChange($event)"
    [searchPlaceholder]="('search.facetSearchPlaceholder' | cxTranslate) + ' ' + attribute?.label"
    [label]="attribute?.elementPlaceholder || attribute?.label"
    [disabled]="(hasPendingChangesService.hasPendingChanges() | async) || null"
    [supportingText]="getSupportingText()"
    [valueState]="getValueState()"
    height="12.5rem">
    <ng-container *ngIf="!isManageCloudAccessSection(attribute?.label || ''); else manageCloudAccess">
      <udex-select-box-item
        *ngFor="let item of attribute.values"
        class="body--s"
        [label]="item?.valueDisplay"
        [value]="item?.valueCode"
        [selected]="getSelectedValue()?.valueCode === item?.valueCode">
      </udex-select-box-item>
    </ng-container>
    <ng-template #manageCloudAccess>
      <ng-container *ngIf="isGlobalAccounts(attribute?.label || '')">
        <udex-select-box-item
          *ngFor="let item of attribute.values"
          class="body--s"
          [label]="getParsedLabel(item?.valueCode || '')"
          [value]="item?.valueCode"
          [selected]="getSelectedValue()?.valueCode === item?.valueCode">
          <b><span [innerHtml]="getParsedHTMLSnippet(item)"></span></b>
          <span [innerHtml]="parseDescription(item.description)"></span>
        </udex-select-box-item>
      </ng-container>
      <ng-container *ngIf="isSystemSelection(attribute?.label || '')">
        <udex-select-box-item
          *ngFor="let item of attribute.values"
          class="body--s"
          [label]="getParsedLabel(item?.valueCode || '')"
          [value]="item?.valueCode"
          [selected]="getSelectedValue()?.valueCode === item?.valueCode">
          <div [innerHtml]="getParsedHTMLSnippet(item)"></div>
        </udex-select-box-item>
      </ng-container>
      <ng-container *ngIf="isSelectContract(attribute?.label || '')">
        <udex-select-box-item
          *ngFor="let item of attribute.values"
          class="body--s"
          [label]="getParsedSelectContractLabel(item?.valueCode || '')"
          [value]="item?.valueCode"
          [selected]="getSelectedValue()?.valueCode === item?.valueCode">
          <div [innerHtml]="getParsedSelectContractSnippet(item)"></div>
        </udex-select-box-item>
      </ng-container>
    </ng-template>
  </udex-select-box>
</div>
